<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="Node2SettingsHubNotResponding-topCurve-wrapper lxn-w100">
      <CustomCurve>
      </CustomCurve>
    </div>
    <div class="Node2SettingsHubNotResponding-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg viewBox="0 0 113.39 113.39">
            <g transform="translate(175.085 -251.936)">
              <path class="Node2SettingsHubNotResponding-st0" d="M-154.39,251.94h72c11.43,0,20.69,9.26,20.69,20.69v72c0,11.43-9.26,20.69-20.69,20.69h-72c-11.43,0-20.69-9.26-20.69-20.69v-72C-175.09,261.2-165.82,251.94-154.39,251.94z"/>
              <path class="Node2SettingsHubNotResponding-st1" d="M-77.48,353.99c0,0-15.68,2.86-40.91,2.86s-40.91-2.86-40.91-2.86c-2.46,0-4.45-1.99-4.45-4.45c0,0-2.86-15.68-2.86-40.91s2.86-40.91,2.86-40.91c0-2.46,1.99-4.45,4.45-4.45h0c0,0,15.68-2.86,40.91-2.86s40.91,2.86,40.91,2.86c2.46,0,4.45,1.99,4.45,4.45l0,0c0,0,2.86,15.68,2.86,40.91s-2.86,40.91-2.86,40.91C-73.03,352-75.02,353.99-77.48,353.99C-77.48,353.99-77.48,353.99-77.48,353.99z"/>
            </g>
            <path class="Node2SettingsHubNotResponding-st2" d="M70.78,75.27c-6.01,10.51-21.16,10.51-27.18,0l-11.22-19.6c-5.98-10.44,1.56-23.44,13.59-23.44h22.44c12.03,0,19.56,13,13.59,23.44L70.78,75.27z"/>
            <rect x="53.97" y="65.85" class="Node2SettingsHubNotResponding-st3" width="6.45" height="6.45"/>
            <rect x="53.97" y="40.06" class="Node2SettingsHubNotResponding-st3" width="6.45" height="19.34"/>
          </svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.Node2SettingsHubNotResponding_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.Node2SettingsHubNotResponding_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
    <div class="Node2SettingsHubNotResponding-button lxn-margin-auto lxn-w100">
      <CustomButton @click="next" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.Node2SettingsHubNotResponding_button}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomButton from '@/components/CustomButton.vue'


export default {
  name: 'Node2SettingsHubNotResponding',
  components: {
    CustomCurve,
    WrapperSvgTitleText,
    CustomButton
  },
  methods: {
    next: function () {
      this.$router.go(-1);
    }
  }
}
</script>

<style>
  .Node2SettingsHubNotResponding-topCurve-wrapper {
    height: 200px;
  }
  .Node2SettingsHubNotResponding-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .Node2SettingsHubNotResponding-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
	.Node2SettingsHubNotResponding-st0 {
    fill: #ECECEC;
  }
	.Node2SettingsHubNotResponding-st1 {
    fill: #53636C;
  }
	.Node2SettingsHubNotResponding-st2 {
    fill: #FFFFFF;
  }
	.Node2SettingsHubNotResponding-st3 {
    fill: #F36C4F;
  }
</style>
